/**
 * 日志脱敏工具(纯函数,零依赖供 jest 钉住)
 *
 * 请求日志会打印请求头/参数/请求体,其中可能含登录密码、改密新旧密码、
 * 各类操作口令与 Bearer token。打印前统一经本函数把敏感键的值替换为
 * 掩码,键名大小写不敏感;只读拷贝,不改动原对象(原对象仍要发给后端)。
 */
import { isPlainObject } from './index';

/** 需要脱敏的键名(统一小写比较) */
export const SENSITIVE_KEYS = [
  'password',
  'oldpassword',
  'newpassword',
  'confirmpassword',
  'authorization',
  'token',
  'accesstoken',
  'apitoken',
  'ftppassword',
  'tsmsapitoken',
];

export const REDACTED = '******';

/** 递归脱敏:普通对象/数组按键名替换敏感值,其他类型原样返回 */
export function redactSensitive<T>(value: T): T {
  if (Array.isArray(value)) {
    return value.map((item) => redactSensitive(item)) as unknown as T;
  }
  if (isPlainObject(value)) {
    const out: Record<string, unknown> = {};
    for (const [key, v] of Object.entries(value)) {
      out[key] = SENSITIVE_KEYS.includes(key.toLowerCase())
        ? REDACTED
        : redactSensitive(v);
    }
    return out as T;
  }
  return value;
}
